import { ISelectOption, Modal as TwsModal } from '@aon/aon-tws-common-ui';
import React from 'react';
import styled from 'styled-components';
import ContentConstants from '../../../../contentConstants';
import { ElementType, IPageFlowElementModel, ISurveyQuestionEditModel } from '../../../../models';

export interface IPageFlowElementModalProps {
	isOpen: boolean;
	onClose: () => any;
	onSubmit: (pageFlowElements: IPageFlowElementModel[]) => any;
	questions: ISurveyQuestionEditModel[];
	maxId: number;
	maxSequence?: number;
	elementType: ElementType;
	pageFlowElement?: IPageFlowElementModel;
	supportedCultures?: string[];
	availableCultures?: ISelectOption[];
	defaultCultureCode?: string;
	title?: string;
	contentFullWidth?: boolean;
	modalType?: string;
	children?: JSX.Element;
}

const ModalContainer = styled.div.attrs<{}>({
	className: 'tws-page-flow-modal',
})`
	width: 100%;
	.tws-question-row {
		align-items: center;
	}
	.tws-afterevery-row,
	.tws-section-header-question {
		align-items: center;
		margin-top: 50px;
	}
	.tws-section-header-translations {
		align-items: top;
		margin-top: 50px;
	}
	.tws-position-row {
		align-items: top;
		margin-top: 50px;
	}
	.tws-description-text,
	.tws-section-header {
		align-items: top;
	}
	.tws-description-text-translations {
		align-items: top;
		margin-top: 50px;
	}
`;
ModalContainer.displayName = 'ModalContainer';

export const PageFlowElementModal = (props: IPageFlowElementModalProps) => {
	return (
		<TwsModal
			isOpen={props.isOpen}
			title={props.title}
			primaryButtonText={ContentConstants.BUTTONS_DONE}
			secondaryButtonText={ContentConstants.BUTTONS_CANCEL}
			contenthcentered={true}
			contentvcentered={true}
			contentfullwidth={props.contentFullWidth}
			type={props.modalType}
			contentoverflow={true}
			onClosed={props.onClose}
			onSubmit={props.onSubmit}
		>
			<ModalContainer>{props.children}</ModalContainer>
		</TwsModal>
	);
};
